(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  function updateDeliveryCountdown() {
    // Use the global shopifyNow variable set in theme.liquid
    const now = new Date(window.shopifyNow);
    
    // Since shopifyNow is static when the page loads, we need to adjust it 
    // by adding the elapsed time since page load
    const elapsedMs = new Date().getTime() - window.pageLoadTime;
    now.setTime(now.getTime() + elapsedMs);
    
    // Create cutoff time - 2PM cutoff
    let cutoffTime = new Date(now);
    cutoffTime.setHours(14, 0, 0, 0);
    
    // Calculate delivery date from the current date
    let deliveryDate = new Date(now);
    
    // If past cutoff, move cutoff time to next business day
    if (now.getHours() >= 14) {
      // Set cutoff time to 2PM next day
      cutoffTime.setDate(cutoffTime.getDate() + 1);
      deliveryDate.setDate(deliveryDate.getDate() + 2);
      
      // Check if next day is weekend
      const nextDay = cutoffTime.getDay();
      if (nextDay === 6) { // Saturday
        cutoffTime.setDate(cutoffTime.getDate() + 2); // Move to Monday
        deliveryDate.setDate(deliveryDate.getDate() + 2);
      } else if (nextDay === 0) { // Sunday
        cutoffTime.setDate(cutoffTime.getDate() + 1); // Move to Monday
        deliveryDate.setDate(deliveryDate.getDate() + 1);
      }
    } else {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
    
    // Skip weekends for delivery date
    const dayOfWeek = deliveryDate.getDay();
    
    // If it's Saturday (6), move to Monday
    if (dayOfWeek === 6) {
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    }
    // If it's Sunday (0), move to Monday
    else if (dayOfWeek === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
    
    // Calculate time remaining until cutoff
    const timeRemaining = cutoffTime - now;
    
    // Format the remaining time, always positive since we adjust cutoff date
    let totalSeconds = Math.floor(timeRemaining / 1000);
    
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    // Create display strings
    const countdownDisplay = hours + " hrs, " + minutes + " mins and " + seconds + " secs";
    
    // Format the delivery date properly
    const deliveryDay = deliveryDate.getDate();
    const deliveryMonth = deliveryDate.toLocaleString('en-US', { month: 'long' });
    const deliveryWeekday = deliveryDate.toLocaleString('en-US', { weekday: 'long' });
    
    // Add correct ordinal suffix
    let daySuffix = "th";
    if (deliveryDay % 10 === 1 && deliveryDay !== 11) {
      daySuffix = "st";
    } else if (deliveryDay % 10 === 2 && deliveryDay !== 12) {
      daySuffix = "nd";
    } else if (deliveryDay % 10 === 3 && deliveryDay !== 13) {
      daySuffix = "rd";
    }
    
    const formattedDeliveryDate = `${deliveryWeekday} ${deliveryDay}${daySuffix} ${deliveryMonth}`;
    
    // Update the display
    document.getElementById('countdown-timer').textContent = countdownDisplay;
    document.getElementById('delivery-date').textContent = formattedDeliveryDate;
    
    // Always show the countdown container
    document.querySelector('.delivery-countdown-container').style.display = 'block';
  }
  
  // Store page load time to calculate elapsed time
  window.pageLoadTime = new Date().getTime();
  
  // Initial update
  updateDeliveryCountdown();
  
  // Run every second
  setInterval(updateDeliveryCountdown, 1000);
});
  
  } catch(e) { console.error(e); }
})();
})();
